import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router';

import { iconByType } from '@/redux/dialogs/helper';
import { selectAccountSlug, selectBrainId, selectDialogId } from '@/redux/session/selectors';
import { DialogAlert } from '@/shared/types/dialogAlert';

type Props = {
  title: string;
  body: string;
  type: DialogAlert['type'];
  handleClick: () => void;
  dialogId: string;
};

const AlertSummaryItem = ({ title, body, type, handleClick, dialogId }: Props) => {
  const slug = useSelector(selectAccountSlug);
  const brainId = useSelector(selectBrainId);
  const { t } = useTranslation();
  const selectedDialogId = useSelector(selectDialogId);

  const item = (
    <button
      type="button"
      onClick={handleClick}
      className="flex w-full cursor-pointer flex-col items-start border-b border-border px-4 py-2 text-left whitespace-normal hover:bg-muted/50"
    >
      <span className="flex items-center gap-1 text-sm text-foreground">
        {iconByType({ id: type, size: 16, color: 'var(--muted-foreground)' })}
        <span>{t(title)}</span>
      </span>
      <span className="text-sm text-muted-foreground">{t(body)}</span>
    </button>
  );

  if (dialogId && dialogId !== selectedDialogId) {
    return (
      <Link to={`/${slug}/ai-agents/${brainId}/workflows/dialogs/${dialogId}`} replace>
        {item}
      </Link>
    );
  }
  return item;
};

export default AlertSummaryItem;
